/**
 * Runtime flag key for GP Membership booking availability.
 *
 * The value is produced server-side from the membership feature gate and read
 * by the client through the same-origin `/api/feature-flags` proxy, so the
 * same Docker image can hide the payment option in production while showing it
 * in staging where the gate is enabled.
 */
export const GP_MEMBERSHIP_BOOKING_FLAG_KEY = 'booking.gp-membership';
